



















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Addresses } from '@/util/Addresses';
import {
  AddressDto, BlockDto,
  DeliveryMethodDto,
  OrderFragmentDto,
  PaymentMethodDto,
  ShoppingCartItemGroupDto,
} from '@/api';
import DeliverySection from '@/views/order-checkout/common/DeliverySection.vue';
import OrderGroup from '@/views/product/widgets/OrderGroup.vue';
import BlocksDispatcher from '@/views/cms/BlocksDispatcher.vue';

@Component({
  components: {DeliverySection, OrderGroup, BlocksDispatcher},
})
export default class OrderDetailView extends Vue {

  @Prop({required: true})
  public orderItemGroups!: ShoppingCartItemGroupDto[];

  @Prop({required: false})
  private billingAddress?: AddressDto | undefined;

  @Prop({required: false})
  private deliveryAddress?: AddressDto | undefined;

  @Prop({required: true})
  private email!: string;

  @Prop({required: false})
  private paymentMethod?: PaymentMethodDto;

  @Prop({required: true})
  private deliverySlotStartTime!: Date;

  @Prop({required: true})
  private deliverySlotEndTime!: Date;

  @Prop({required: false})
  private deliveryMethod?: DeliveryMethodDto;

  @Prop({required: true})
  private totalItemPrice!: string;

  @Prop({required: true})
  private totalDeposit!: string;

  @Prop({required: true})
  private shippingFee!: string;

  @Prop({required: true})
  private totalPrice!: string;

  @Prop({required: true})
  private totalDiscount!: string;

  @Prop({required: true})
  private hasDiscount!: boolean;

  @Prop({required: false})
  private couponDiscount?: string;

  @Prop({required: false})
  private orderFragment?: OrderFragmentDto;

  get currentOrderItemGroups(): ShoppingCartItemGroupDto[] {
    return this.orderItemGroups;
  }

  get billingAddressString(): string {
    if (this.billingAddress) {
      return Addresses.toString(this.billingAddress);
    }

    return '';
  }

  get deliveryAddressString(): string {
    if (this.deliveryAddress) {
      return Addresses.toString(this.deliveryAddress);
    }

    return '';
  }

  get emailString(): string {
    return this.email ?? '';
  }

  get telephoneString(): string {
    return this.deliveryAddress?.telephone ?? '';
  }

  get currentPaymentMethod() {
    return this.paymentMethod;
  }

  get currentDeliverySlotStartTime(): Date {
    return new Date(this.deliverySlotStartTime!!);
  }

  get currentDeliverySlotEndTime(): Date {
    return new Date(this.deliverySlotEndTime!!);
  }

  get currentDeliveryMethod() {
    return this.deliveryMethod;
  }

  get itemTotal() {
    return this.totalItemPrice;
  }

  get depositTotal() {
    return this.totalDeposit;
  }

  get shippingFeeString() {
    return this.shippingFee;
  }

  get cartTotal() {
    return this.totalPrice;
  }

  get discountTotal() {
    return this.totalDiscount;
  }

  get currentHasDiscount() {
    return this.hasDiscount;
  }

  get currentCouponDiscount() {
    return this.couponDiscount;
  }

  get deliveryImage(): string | null {
    if (this.currentDeliveryMethod === DeliveryMethodDto.DELIVERY) {
      return this.orderFragment?.imageDelivery ?? null;
    } else {
      return this.orderFragment?.imagePickup ?? null;
    }
  }

  get sideBlocks(): BlockDto[] {
    return this.orderFragment?.sideBlocks ?? [];
  }

  get summaryBlocks(): BlockDto[] {
    return this.orderFragment?.summaryBlocks ?? [];
  }
}
